import React, { useState } from 'react';
import { Bell, User, Menu, LogOut, Settings as SettingsIcon } from 'lucide-react';
interface HeaderProps {
  onMenuClick: () => void;
  onLogout: () => void;
  companyName?: string;
  userName?: string;
  userEmail?: string;
}
export function Header({
  onMenuClick,
  onLogout,
  companyName = 'Edilcassa Veneto',
  userName = 'Mario Rossi',
  userEmail = 'mario.rossi@cnce.it'
}: HeaderProps) {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  return <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 lg:px-6 fixed top-0 right-0 left-0 lg:left-64 z-10" data-id="element-67">
      {/* Mobile Menu Button */}
      <button onClick={onMenuClick} className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-68">
        <Menu size={24} data-id="element-69" />
      </button>

      {/* Company Name */}
      <div data-id="element-70">
        <h2 className="text-lg lg:text-xl font-semibold text-gray-900" data-id="element-71">
          {companyName}
        </h2>
      </div>

      {/* User Actions */}
      <div className="flex items-center gap-2 lg:gap-4" data-id="element-72">
        <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-73">
          <Bell size={20} data-id="element-74" />
        </button>

        {/* User Info & Menu */}
        <div className="relative" data-id="element-75">
          <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-76">
            <div className="hidden lg:flex flex-col items-end" data-id="element-77">
              <span className="text-sm font-medium text-gray-900" data-id="element-78">
                {userName}
              </span>
              <span className="text-xs text-gray-600" data-id="element-79">{userEmail}</span>
            </div>
            <User size={20} data-id="element-80" />
          </button>

          {/* User Dropdown */}
          {isUserMenuOpen && <>
              {/* Backdrop for mobile */}
              <div className="fixed inset-0 z-10 lg:hidden" onClick={() => setIsUserMenuOpen(false)} data-id="element-81" />

              <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-20" data-id="element-82">
                {/* User Info */}
                <div className="px-4 py-3 border-b border-gray-200 bg-gray-50" data-id="element-83">
                  <p className="text-sm font-semibold text-gray-900" data-id="element-84">
                    {userName}
                  </p>
                  <p className="text-xs text-gray-600" data-id="element-85">{userEmail}</p>
                </div>

                {/* Menu Items */}
                <div className="py-2" data-id="element-86">
                  <button className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-87">
                    <SettingsIcon size={16} data-id="element-88" />
                    <span data-id="element-89">Impostazioni</span>
                  </button>
                  <button onClick={() => {
                setIsUserMenuOpen(false);
                onLogout();
              }} className="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors" data-id="element-90">
                    <LogOut size={16} data-id="element-91" />
                    <span data-id="element-92">Esci</span>
                  </button>
                </div>
              </div>
            </>}
        </div>
      </div>
    </header>;
}